"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aliases = {
    "mathfrak": "frak",
    "mathcal": "cal",
    "mathbb": "bb",
    "mathbf": "bf",
    "dfrac": "frac",
    "ldots": "dots"
};
//# sourceMappingURL=command-aliases.js.map